"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _Promotions = require("self-service-api/constants/Promotions");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _PromotionBanner = _interopRequireDefault(require("./PromotionBanner"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  max-width: 1100px;\n\n  &:not(:empty) {\n    margin-bottom: 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBannerSection = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteBannerSection__StyledBannerSection",
  componentId: "sc-125w2y3-0"
})(_templateObject()); // Currently only used to display 50% off LATAM-ES promotion


var GrowthSuiteBannerSection = function GrowthSuiteBannerSection(_ref) {
  var isLatamEsEligible = _ref.isLatamEsEligible;
  return _react.default.createElement(StyledBannerSection, null, isLatamEsEligible && _react.default.createElement(_PromotionBanner.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.latamEs.growthSuite.title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.latamEs.growthSuite.body_jsx",
      elements: {
        UILink: _UILink.default
      },
      options: {
        url: (0, _urls.getLatamEsPromotionUrl)()
      }
    }),
    promotion: _Promotions.promotionKeys.LATAM_ES,
    dataSelenium: _Promotions.promotionKeys.LATAM_ES.toLowerCase() + "-promotion-header"
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLatamEsEligible: (0, _PromotionSelectors.isLatamEsEligibleSelector)(state)
  };
};

GrowthSuiteBannerSection.propTypes = {
  isLatamEsEligible: _propTypes.default.bool.isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteBannerSection);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/GrowthSuiteBannerSection.js
// module id = 870
// module chunks = 5 6